import api from "./api";
const vinculosService = {
  listar:   (idUnidade) => api("GET",`/vinculos?idUnidade=${idUnidade}`),
  criar:    (data)      => api("POST","/vinculos",data),
  atualizar:(id,data)   => api("PUT",`/vinculos/${id}`,data),
  inativar: (id,data)   => api("PATCH",`/vinculos/${id}/inativar`,data),
};
export default vinculosService;
